<template>
    <HeaderBar></HeaderBar>
   <div id="main-container">
    <router-view />
   </div>
    <FooterBar></FooterBar>
</template>

<script>
import HeaderBar from "@/views/layout/HeaderBar";
import FooterBar from "@/views/layout/FooterBar";
export default {
  name: "MainLayout",
  components: {HeaderBar, FooterBar},
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang='scss' >

.pager{
  margin-top: 20px;
}
.mark-title{
  margin: 0 0 20px 0;
  color: var(--scheme-color5);
}
#main-container{
  min-height:calc(100vh - 400px);
}
</style>